import { UserRolesRestResource } from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { CreateUserRolesRequest } from "./create-user-roles/CreateUserRolesRequest";
import { CreateUserRolesResponse } from "./create-user-roles/CreateUserRolesResponse";
import { DeleteUserRolesRequest } from "./delete-user-roles/DeleteUserRolesRequest";
import { DeleteUserRolesResponse } from "./delete-user-roles/DeleteUserRolesResponse";
import { GetUserRolesRequest } from "./get-user-roles/GetUserRolesRequest";
import { GetUserRolesResponse } from "./get-user-roles/GetUserRolesResponse";

export const useGetUserRoles = () =>
  useRestResourceHook<GetUserRolesRequest, GetUserRolesResponse>((request) =>
    UserRolesRestResource.getUserRoles(request),
  );

export const useCreateUserRoles = () =>
  useRestResourceHook<CreateUserRolesRequest, CreateUserRolesResponse>(
    (request) => UserRolesRestResource.createUserRoles(request),
  );

export const useDeleteUserRoles = () =>
  useRestResourceHook<DeleteUserRolesRequest, DeleteUserRolesResponse>(
    (request) => UserRolesRestResource.deleteUserRoles(request),
  );
